import { context } from "components/context/Context";
import * as React from "react";
import { Route, useHistory, useLocation } from "react-router";

interface IProps {
  path: string;
  exact?: boolean;
  requireGid?: boolean;
  showSetting: number;
  children: React.ReactNode;
}

const PageRoute = ({
  path,
  exact = false,
  requireGid = false,
  children,
  showSetting,
}: IProps) => {
  const history = useHistory();
  const { state } = React.useContext(context);
  const location = useLocation();
  const cannotShow = () => {
    alert("此頁面被設定為不顯示");
    history.goBack();
  };
  const forbidden = () => {
    alert("权限不足");
    history.goBack();
  };
  const notLoggedIn = () => {
    alert("您需要登入");
    history.push("/login");
  };
  React.useEffect(() => {
    if (Object.keys(state).length !== 0) {
      if (!state.gid) {
        // console.log("沒有gid");
      } else if (requireGid) {
        // console.log("有gid, 也需要確認鴿會有無顯示設定");
      }
      switch (showSetting) {
        case 0:
          cannotShow();
          break;
        case 1:
          break;
        case 2:
          if (!state.character) {
            notLoggedIn();
          } else if (
            state.character === "Admin" ||
            state.character === "Club"
          ) {
            break;
          } else {
            forbidden();
            break;
          }
          break;
        case 3:
          if (!state.character) {
            notLoggedIn();
          } else if (state.character !== "Admin") {
            forbidden();
          }
          break;
      }
    }
  }, [state, location]);
  return (
    <Route path={path} exact={exact}>
      {children}
    </Route>
  );
};

export default PageRoute;
